/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    SlackChannelLink,
    SlackChannelLinkFromJSON,
    SlackChannelLinkToJSON,
} from './';

/**
 * 
 * @export
 * @interface Slack
 */
export interface Slack {
    /**
     * 
     * @type {string}
     * @memberof Slack
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof Slack
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof Slack
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof Slack
     */
    botUserId: string;
    /**
     * 
     * @type {Array<SlackChannelLink>}
     * @memberof Slack
     */
    channelLinks?: Array<SlackChannelLink>;
}

export function SlackFromJSON(json: any): Slack {
    return {
        'teamId': json['teamId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'accessToken': json['accessToken'],
        'botUserId': json['botUserId'],
        
        'channelLinks': !exists(json, 'channelLinks') ? undefined : (json['channelLinks'] as Array<any>).map(SlackChannelLinkFromJSON),
        
    };
}

export function SlackToJSON(value?: Slack): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'teamId': value.teamId,
        'teamName': value.teamName,
        'accessToken': value.accessToken,
        'botUserId': value.botUserId,
        
        'channelLinks': value.channelLinks === undefined ? undefined : (value.channelLinks as Array<any>).map(SlackChannelLinkToJSON),
        
    };
}


